const routes = {
  getCurrencies: 'system/currencies',
  updateCurrencyRate: 'system/updateCurrency',
  getCurrenciesLogs: 'system/currencies/logs',
};

export default routes